import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import Experience, { Role } from "../components/experience/Experience";

export default function ExperiencePage() {
  return (
    <div className="sections">
      <div className="page-hero">
        <h1 className="page-title">Every role, in full.</h1>
        <p className="page-blurb">
          From founding my first game studio to building the biggest volleyball
          game in the world: where I've worked and what I built there.
        </p>
        <Link className="back-link" to="/"><ArrowLeft size={14} weight="bold" /> Back home</Link>
      </div>
      <Experience />
      <div className="experience">
        <div className="roles">
          <Role
            company="University of Minnesota"
            title="Honors Student"
            period="2023 to 2026"
            summary="B.S. in Computer Science through the University Honors Program."
          />
        </div>
      </div>
    </div>
  );
}
